module.exports = function (Restangular) {
    function ProxyService() {
        this._api = Restangular.one('proxy');
    }

    ProxyService.prototype.get = function (path, proxyname, config) {
        return this._api.get({ path, proxyname, config });
    };

    ProxyService.prototype.post = function (path, proxyname, body, config) {
        return this._api.post('', { path, proxyname, body, config });
    };

    ProxyService.prototype.put = function (path, proxyname, body, config) {
        return this._api.customPUT({ path, proxyname, body, config });
    };

    return new ProxyService();
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/wowcommon/proxyservice/proxy-service.js
 **/